import React from 'react';
import * as S from './estilos';
import ImgEstacionamento from '../../Images/ImgEstacionamento.jpg';
import ImgMapa from '../../Images/ImgMapa.jpg';
import ImgMapaResp from '../../Images/ImgMapaResp.jpg';
function Banner() {
  return (
    <>
      <div className='Ancora' id='Estacionamento'></div>
      <S.ForaEsta>
        <S.EsqEstac>
          <S.TextEsta1>estacionamento</S.TextEsta1>
          <S.TextEsta1Baixo>Com diversas opções</S.TextEsta1Baixo>
          <S.ForaItensEsta>
            <S.ItemEsta>
              <S.TextDirItemEstaResp>1</S.TextDirItemEstaResp>
              <S.EsqItemEsta>
                <S.TextItemEsta>PARX</S.TextItemEsta>
                <S.TextItemEsta2>Rua Julio Gonzales, 132</S.TextItemEsta2>
              </S.EsqItemEsta>
              <S.TextDirItemEsta>1</S.TextDirItemEsta>
            </S.ItemEsta>
            <S.ItemEsta>
              <S.TextDirItemEstaResp>2</S.TextDirItemEstaResp>
              <S.EsqItemEsta>
                <S.TextItemEsta>VIA +</S.TextItemEsta>
                <S.TextItemEsta2>Av. Francisco Matarazzo, 892</S.TextItemEsta2>
              </S.EsqItemEsta>
              <S.TextDirItemEsta>2</S.TextDirItemEsta>
            </S.ItemEsta>
            <S.ItemEsta>
              <S.TextDirItemEstaResp>3</S.TextDirItemEstaResp>
              <S.EsqItemEsta>
                <S.TextItemEsta>TREVO ESTACIONAMENTOS</S.TextItemEsta>
                <S.TextItemEsta2>Rua Tagipuru, 931</S.TextItemEsta2>
              </S.EsqItemEsta>
              <S.TextDirItemEsta>3</S.TextDirItemEsta>
            </S.ItemEsta>
            <S.ItemEsta>
              <S.TextDirItemEstaResp>4</S.TextDirItemEstaResp>
              <S.EsqItemEsta>
                <S.TextItemEsta>TREVO ESTACIONAMENTOS</S.TextItemEsta>
                <S.TextItemEsta2>Rua Tagipuru, 835 / Av. Francisco Matarazzo, 664</S.TextItemEsta2>
              </S.EsqItemEsta>
              <S.TextDirItemEsta>4</S.TextDirItemEsta>
            </S.ItemEsta>
            <S.ItemEsta>
              <S.TextDirItemEstaResp>5</S.TextDirItemEstaResp>
              <S.EsqItemEsta>
                <S.TextItemEsta>BRASIL PARK</S.TextItemEsta>
                <S.TextItemEsta2>Rua Tagipuru, 733</S.TextItemEsta2>
              </S.EsqItemEsta>
              <S.TextDirItemEsta>5</S.TextDirItemEsta>
            </S.ItemEsta>
          </S.ForaItensEsta>
        </S.EsqEstac>
        <S.DirEsta>
          <S.ImagemEstacionamento src={ImgEstacionamento} />
        </S.DirEsta>
      </S.ForaEsta>

      <a
        target='_blank'
        rel='noreferrer'
        href='https://www.google.com/maps/dir//R.+Tagipuru,+1001+-+Barra+Funda,+S%C3%A3o+Paulo+-+SP,+01156-000/@-23.5270742,-46.6699491,17z/data=!4m17!1m7!3m6!1s0x94ce5801f8f1cbad:0xd57240558c5ce05b!2sR.+Tagipuru,+1001+-+Barra+Funda,+S%C3%A3o+Paulo+-+SP,+01156-000!3b1!8m2!3d-23.5270742!4d-46.6699491!4m8!1m0!1m5!1m1!1s0x94ce5801f8f1cbad:0xd57240558c5ce05b!2m2!1d-46.6699491!2d-23.5270742!3e3'
        id='Localizacao'>
        <S.ImagemMapa src={ImgMapa} />
        <S.ImagemMapaResp src={ImgMapaResp} />
      </a>
    </>
  );
}

export default Banner;
